<template>
  <div class="my-4 mx-md-5 mx-lg-10 mx-xl-10 pa-2 pt-md-0 px-md-4 maxw-1750">
    <h2 v-if="this.pathname && !this.pathname.includes('/search')">
      {{ $t('menu.kdbList') }}
    </h2>
    <v-card v-if="renderFilters">
      <v-row
        no-gutters
        class="mt-4 px-4 pb-4"
        align="center"
        justify="start"
      >
      <!-- :placeholder="$t(`views.${typeKis}.searchText`)" -->
        <v-text-field
          id="placeholder__knowledge"
          v-model="searchText"
          clearable
          hide-details
          single-line
          placeholder=""
          prepend-icon="mdi-magnify"
          @click:clear="search({}, 0)"
          @click:prepend="search({ text: searchText }, 0)"
          @keyup.enter="search({ text: searchText }, 0)"
        />
      </v-row>
      <v-card-text
        v-if="isKnowledge && listType != null && items.length > 0 && typeKis !== 'faqsItems'"
        class="pt-0"
      >
        <!-- chip style for other messages -->
        <v-chip
          label
          color="primary"
        >
          {{
            $tc(`views.knowledgeItems.listType.${listType}`, items.length)
          }}
        </v-chip>
      </v-card-text>
    </v-card>

    <template v-if="isSearchNav ? loading : !isKnowledge && items.length === 0">
      <template v-for="i in 7">
        <v-card :key="i" class="mt-4 py-2">
          <v-skeleton-loader
            :key="i"
            type="list-item"
            class="mx-auto"
          ></v-skeleton-loader>
        </v-card>
      </template>
    </template>

    <template
      v-if="(isSearchNav ? !loading : isKnowledge) && items.length === 0
        && listType != null && typeKis === 'knowledgeItems'">
        <!-- list item as empty list message -->
      <div class="mt-4 text-body">
          <span
            v-html="$t('views.globalSearch.requestsItems.notFoundSearch',
            [querySearch || dataSearch])">
          </span>
      </div>
    </template>

    <template v-if="isKnowledge && !items.length && typeKis === 'faqsItems'">
        <!-- list item as empty list message -->
      <div class="mt-4 text-body">
        {{ $t("views.faqsItems.empty") }}
        <router-link
          :to="parseQueryParams()"
        >
          {{ $t("views.faqsItems.url.text") }}
        </router-link>
      </div>
    </template>

    <template v-if="items.length">
      <ListItem
        class="pt-1 pb-1 pl-1 ki--list-item"
        v-for="(item, i) in items"
        :key="i"
        :url="`${url}${item.id}`"
      >
        <template slot="title">
          <div class="inlineFlexMW90">
            <div class="alignItemCenter">
              <span class="titleSolutions">{{item.name}}</span>
              <v-spacer />

              <div
                v-bind:class="[
                'mw-25 mt-2 mt-sm-0 pa-0 pl-sm-2',
                'd-inline-flex flex-nowrap',
                ($vuetify.breakpoint.mdAndUp ? 'justify-end' : 'justify-space-around' )
                ]"
              >
                <div class="iconsSolutions">
                  <!-- <v-icon class="mr-1" v-if="item.isTechnical">
                    icon-ayudadigital-soluciones
                  </v-icon> -->
                  <v-btn
                    width="24"
                    height="24"
                    class="mr-1"
                    icon
                    @click.prevent="$event => share($event, item)"
                  >
                    <v-icon color="primary">mdi-share-variant</v-icon>
                  </v-btn>
                </div>
                <v-spacer v-if="$vuetify.breakpoint.smAndDown" />
                <v-chip
                  v-if="item.hits"
                  class="knowledge__rating"
                  label
                  small>
                  <v-rating
                    v-if="item.avgRating != null"
                    half-increments
                    length="5"
                    :readonly="true"
                    :value="item.avgRating"
                  >
                    <template v-slot:item="{
                      index, isFilled, isHalfFilled,
                    }">
                      <v-icon
                        x-small
                        color="primary"
                        :class="['pa-0', 'ml-0']"
                        v-text="`mdi-star${!isFilled ? (
                          isHalfFilled ? '-half-full' : '-outline'
                        ) : ''}`"
                      ></v-icon>
                    </template>
                  </v-rating>
                </v-chip>
              </div>

            </div>
            <div class="alignItemCenter">
              <span
                class="subtitleSolutions"
                :class="{ 'text-truncate-mobile': isMobileResponsive }"
              >
                {{ item.snippet }}
              </span>
            </div>
          </div>
        </template>
      </ListItem>

    </template>

    <ShareDialog
      :visible="openDialog"
      @input="openDialog = false"
      :item="sharedItem || {}"
      :positionX="sharedDialogPosition.positionX"
      :positionY="sharedDialogPosition.positionY"
    ></ShareDialog>
  </div>
</template>

<script>
import Superplaceholder from 'superplaceholder';
import { ListItem, ShareDialog } from '@/components';

export default {
  props: {
    renderFilters: {
      type: Boolean,
      default: () => true,
    },
    updatePathOnSearch: {
      type: Boolean,
      default: () => true,
    },
    loading: Boolean,
    isCatalog: Boolean,
    isKnowledge: Boolean,
    isRequest: Boolean,
    text: String,
    listType: String,
    items: {
      type: Array,
      default: () => ([]),
    },
    lastSearchArgs: {
      type: Object,
      default: () => ({}),
    },
    typeKis: {
      type: String,
      default: () => 'knowledgeItems',
    },
    querySearch: String,
  },
  data: ({ text }) => ({
    sharedItem: null,
    sharedDialogPosition: {},
    searchText: text || null,
    openDialog: false,
    inputValue: '',
    placeholderInstance: null,
    pathname: null,
    dataSearch: '',
    isSearchNav: false,
  }),
  components: {
    ListItem,
    ShareDialog,
  },
  methods: {
    search(filters = {}, page) {
      this.dataSearch = filters.text;
      if (window.location.pathname.includes('knowledge')) {
        this.isSearchNav = true;
      }
      if (!this.loading) {
        this.$emit('request', {
          type: 'list',
          args: {
            filters,
            page,
          },
        });
        if (this.updatePathOnSearch) {
          let newPath = this.$route.path;
          if (typeof filters.text === 'string') {
            newPath += `?text=${filters.text}`;
          }
          this.$router.push(newPath)
            .catch(() => {}); // ignoring avoided redundant navigation exceptions
        }
      }
    },
    share(evt, item) {
      console.log('evt', evt);
      evt.preventDefault();

      const isMobile = this.$store.getters['globalState/get']('deviceOS') != null;

      const knowledgeUrl = 'knowledge-items/';

      const fullShareUrl = `${process.env.VUE_APP_EXTERNAL_URL}${process.env.VUE_APP_BASE_URL_MICS_SSPA}${knowledgeUrl}${item.id}`;

      if (isMobile === true && window.flutter_inappwebview) {
        const args = {
          name: this.$t('components.share.mobile.knowledgeItems'),
          url: fullShareUrl,
          formName: item.name,
          type: 'KI',
        };
        window.flutter_inappwebview.callHandler('shareDataUsingNative', args);
      } else {
        this.openDialog = true;
        this.sharedItem = {
          text: `${this.$t('components.share.subjectBody.knowledge')} ${item.name}`,
          url: fullShareUrl,
          formName: item.name,
          type: 'KI',
        };
        const closestButton = evt.target.closest('button');
        const boundingRect = closestButton.getBoundingClientRect();

        this.sharedDialogPosition = {
          positionX: boundingRect.left + (closestButton.offsetWidth / 2),
          positionY: boundingRect.top + (closestButton.offsetHeight / 2),
        };
      }
    },
    parseQueryParams() {
      const { text } = this;
      return `element/r/${this.$getConst('faqs.idFormApplication')}/?description=${text}&app=${this.$getConst('faqs.idApplicationMics')}`;
    },
  },
  computed: {
    filters() {
      const { text } = this;
      return { text };
    },
    url() {
      const path = window.location.pathname.split('/');
      const pathLength = path.length;
      if (path[pathLength - 1] === '') {
        path.pop();
      }
      const uuidCi = [...path].pop();
      return this.typeKis === 'knowledgeItems' ? '/knowledge-items/' : `/soluciones/${uuidCi}/`;
    },
    isHelpWindow() {
      return (window.location.pathname).includes('soluciones');
    },
    isMobileResponsive() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  mounted() {
    this.search(this.filters, 0);
    this.pathname = window.location.pathname;
    const messages = [
      'Describe lo que necesitas en una frase…',
      'No puedo acceder al correo desde mi equipo',
      'La impresora no imprime los documentos que envío',
      'Quiero saber cómo cambiar mi contraseña de acceso',
    ];

    const placeholderInstance = new Superplaceholder({
      el: document.getElementById('placeholder__knowledge'),
      sentences: messages,
      options: {
        loop: true,
        startOnFocus: false,
      },
    });

    placeholderInstance.start();
  },
};
</script>

<style lang="scss">
  .ki--list-item > .v-card__title {
    word-break: break-word;
  }

  .knowledge__rating  {
    background-color: transparent !important;
    padding-left: 0.5rem !important;
  }

  .icon-ayudadigital-soluciones:before {
    font-size: larger !important;
  }
  .inlineFlexMW90{
      display: inline-flex;
      flex-direction: column;
      width: 100%;
  }
  .alignItemCenter{
    display: flex;
    align-items: center !important;
    width: 100%;
    min-width: 0;
  }
  .titleSolutions{
    width: calc(100% - 40px) !important;
    font-size: 0.95rem !important;
  }
  .subtitleSolutions {
    font-size: 0.85rem !important;
  }
  .iconsSolutions{
    display: flex;
  }
  .text-truncate-mobile {
    display: block;
    width: 100%;
    min-width: 0;
    flex: 1 1 auto;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media screen and (max-width: 600px) {
    .titleSolutions{
    width: calc(100% - 40px) !important;
    font-size: 0.85rem !important;
    }
  }

  @media (min-width: 600px) {
    .ki--list-item > .v-card__title {
      flex-wrap: nowrap;
    }
  }
</style>
